import { useQuery } from "@apollo/react-hooks";

import { Instructor } from "@hubcapp/types";
import GetInstructorPropositionDetails from "@hubcapp/graphql/GetInstructorPropositionDetails.graphql";

const useQueryGetPropositionDetails = (id?: string) =>
  useQuery<{
    instructor: Instructor;
  }>(GetInstructorPropositionDetails, {
    variables: { id },
    skip: !id,
  });

export default useQueryGetPropositionDetails;
